import { useEffect, useRef } from "react";

// Renders the pixel-perfect Tally marketing landing at "/" through React.
// A same-origin, full-viewport iframe fully isolates the landing's global CSS
// from the app's Tailwind base styles (which otherwise corrupt the layout) and
// lets the page's own scripts (reveal, FAQ, billing toggle, menu) run natively.
// Internal links are broken out of the iframe into top-level React routes.
export const LandingPage = () => {
  const ref = useRef(null);

  useEffect(() => {
    const iframe = ref.current;
    if (!iframe) return;

    const wireLinks = () => {
      const doc = iframe.contentDocument;
      if (!doc) return;
      doc.querySelectorAll("a[href]").forEach((a) => {
        if (a.dataset.wired) return;
        a.dataset.wired = "1";
        const href = a.getAttribute("href");
        if (!href) return;
        if (href === "#") {
          a.addEventListener("click", (e) => e.preventDefault()); // dead link, no jump
          return;
        }
        if (href.startsWith("#")) return; // in-page anchors scroll inside iframe
        if (href.startsWith("/")) {
          a.addEventListener("click", (e) => { e.preventDefault(); window.location.assign(href); });
        } else if (/^https?:\/\//.test(href)) {
          a.setAttribute("target", "_top");
        }
      });
    };

    iframe.addEventListener("load", wireLinks);
    if (iframe.contentDocument && iframe.contentDocument.readyState === "complete") wireLinks();
    return () => iframe.removeEventListener("load", wireLinks);
  }, []);

  return (
    <iframe
      ref={ref}
      title="Tally — See your money clearly"
      src="/landing.html"
      data-testid="landing-page"
      style={{
        position: "fixed",
        inset: 0,
        border: 0,
        width: "100%",
        height: "100%",
        display: "block",
        background: "#FBFAF5",
      }}
    />
  );
};
